<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Fahrer</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table style="width: 70vw;"
                  :headers="headers"
                  :items="drivers.items.items"
                  :rows-per-page-items="[5,10,20,50,100]"
                  :loading="isLoading"
                  :total-items="totalItems"
                  :must-sort="true"
                  :pagination.sync="pagination"
                  class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.lastname }}</td>
        <td class="text-xs-left">{{ props.item.firstname }}</td>
        <td class="text-xs-left">{{ props.item.perid }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'drivers',
  data() {
    return {
      totalItems: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'lastname'
      },
      headers: [
        {
          text: 'Nachname',
          align: 'left',
          sortable: true,
          value: 'lastname'
        },
        {
          text: 'Vorname',
          align: 'left',
          sortable: true,
          value: 'firstname'
        },
        {
          text: 'Personal ID',
          align: 'left',
          sortable: false,
          value: 'perid'
        }
      ]
    };
  },
  watch: {
    pagination(newValue, oldValue) {
      this.getDataFromApi();
    },
    drivers(newValue, oldValue) {
      console.log(newValue.items.total);
      this.totalItems = newValue.items.total;
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    drivers() {
      return this.$store.state.drivers.all;
    },
    isLoading() {
      return this.$store.state.drivers.loading;
    }
  },
  methods: {
    getDataFromApi() {
      const perpage = this.pagination.rowsPerPage;
      const page = this.pagination.page;
      const sortby = this.pagination.sortBy;
      const descending = this.pagination.descending;

      this.$store.dispatch('drivers/getAll', {
        perpage,
        page,
        sortby,
        descending
      });
    }
  }
};
</script>
